import { useEffect, useState } from 'react';
import SeriesCard from './SeriesCard';
import { getNewSeries, getTrendingSeries } from '../../services/seriesService';

const SeriesRail = ({ title, mode = 'trending', limitCount = 12 }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    (async () => {
      const res = mode === 'new'
        ? await getNewSeries({ limitCount })
        : await getTrendingSeries({ limitCount });
      if (cancelled) return;
      setItems(res.success ? (res.series || []) : []);
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, [mode, limitCount]);

  if (loading) {
    return (
      <div className="mb-8">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">{title}</h2>
        <div className="flex gap-4 overflow-x-auto pb-2 hide-scrollbar">
          {[1,2,3,4,5].map((i) => (
            <div key={i} className="flex-shrink-0 w-56 aspect-[3/4] bg-gray-200 dark:bg-slate-700 rounded-2xl animate-pulse" />
          ))}
        </div>
      </div>
    );
  }

  if (!items.length) return null;

  return (
    <div className="mb-8">
      <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">{title}</h2>
      <div className="flex gap-4 overflow-x-auto pb-2 hide-scrollbar">
        {items.map((s) => <SeriesCard key={s.id} series={s} />)}
      </div>
    </div>
  );
};

export default SeriesRail;

